import { render, staticRenderFns } from "./aigc.vue?vue&type=template&id=b1b15a12&scoped=true&"
import script from "./aigc.vue?vue&type=script&lang=js&"
export * from "./aigc.vue?vue&type=script&lang=js&"
import style0 from "./aigc.vue?vue&type=style&index=0&id=b1b15a12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b15a12",
  null
  
)

export default component.exports